import React from "react";
import { BiMobileVibration, BiMailSend } from "react-icons/bi";
import { MdOutlineMobileFriendly } from "react-icons/md";
import OoPopover from "../../../../components/UI/Popover/OoPopover";
import OtherWaysToShare from "./OtherWaysToShare";

const TrivvySharingOptions = ({
  isSharable,
  resetNumbers,
  getTrivvySharedSMSPreview,
  getTrivvySharedEmailPreview,
  setShareTrivvyViaEmail,
  setShareTrivvyViaSMS,
  setEmailSmsSendModal,
  shareUrl,
  downloadQRCode,
  isMobile,
  copySurveyUrl,
  PlatformSharing
}) => {
  return (
    <div className="sharepage_sharing_options_section">
      <div className="d-flex align-items-center">
        <span className="sharepage_title">Share Your Trivvy Via This Platform</span>
        <OoPopover
          target="enterprise-name-popover"
          placement="right"
          headerText="Platform Sharing"
          bodyText={<PlatformSharing />}
        />
      </div>

      <div
        className={` ${
          isMobile
            ? "sharepage_item_cards_parent_div_mobile"
            : "sharepage_item_cards_parent_div"
        }`}
      >
        <div
          className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
          onClick={async () => {
            resetNumbers();
            await getTrivvySharedEmailPreview(1, 'fromModal');
            // Clear the OTHER channel's local flag to null (not false) so the
            // FE state always reflects the current modal context. Null (vs
            // false) preserves the BE skip-null contract that prevents a
            // manual send from wiping the un-clicked channel's saved config.
            setShareTrivvyViaSMS(null);
            setShareTrivvyViaEmail(true);
            setEmailSmsSendModal({
              open: true,
              type: "EMAIL_LINK",
            });
          }}
        >
          <div className="share_page_card_heading">
            <BiMailSend className="logo-icon" /> Email a Link
          </div>
          <div className="share_page_card_description">
            Email your Trivvy to platform users that you select in the next step.
          </div>
        </div>

        <div
          className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
          onClick={async () => {
            resetNumbers();
            await getTrivvySharedSMSPreview(1, 'fromModal');

            // Clear the OTHER channel's local flag to null (not false) so the
            // FE state always reflects the current modal context. Null (vs
            // false) preserves the BE skip-null contract that prevents a
            // manual send from wiping the un-clicked channel's saved config.
            setShareTrivvyViaEmail(null);
            setShareTrivvyViaSMS(true);
            setEmailSmsSendModal({
              open: true,
              type: "SMS_TRIVVY",
            });
          }}
        >
          <div className="share_page_card_heading">
            <BiMobileVibration className="logo-icon" /> Text ONLY
          </div>
          <div className="share_page_card_description">
            Text your Trivvy (no links) to platform users that you select in the next step.
          </div>
        </div>

        <div
          className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
          onClick={async () => {
            await getTrivvySharedSMSPreview(1, 'fromModal');
            resetNumbers();

            // Clear the OTHER channel's local flag to null (not false) so the
            // FE state always reflects the current modal context. Null (vs
            // false) preserves the BE skip-null contract that prevents a
            // manual send from wiping the un-clicked channel's saved config.
            setShareTrivvyViaEmail(null);
            setShareTrivvyViaSMS(true);
            setEmailSmsSendModal({
              open: true,
              type: "SURVEY_LINK",
            });
          }}
        >
          <div className="share_page_card_heading">
            <MdOutlineMobileFriendly className="logo-icon" /> Text a Link
          </div>
          <div className="share_page_card_description">
            Text a link to platform users that you select in the next step.
          </div>
        </div>
      </div>

<OtherWaysToShare
  isSharable={isSharable}
  shareUrl={shareUrl}
  copySurveyUrl={copySurveyUrl}
  downloadQRCode={downloadQRCode}
  isMobile={isMobile}
  setEmailSmsSendModal={setEmailSmsSendModal}
/>
    </div>
  );
};

export default TrivvySharingOptions;
